"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebouncerPlusEvents = void 0;

var react_1 = __importDefault(require("react"));
/**
 * @desc useDebouncerPlus
 ***********************************************************************
 * @param value - value of original param or state being passed
 * @param delay - time out length as well as well Idle Time Threshold
 * @param idsToWatch - id's of other inputs to be watched for activity
 *  for events (that cancel haveBeenIdle), if events happen  they cancel the timout
 * and debounce doesnt return a value but resets the timer
 * @returns
 * the original value after the timeout threshold has been reached.
 * it will  not return a value UNTIL timeout has been reached, timeouts that expire
 * while the user is interacting with  other elements regenerate the  timeout.
 ***********************************************************************
 */


var DebouncerPlusEvents;

(function (DebouncerPlusEvents) {
  DebouncerPlusEvents["focus"] = "focus";
  DebouncerPlusEvents["change"] = "change";
  DebouncerPlusEvents["mouseout"] = "mouseout";
  DebouncerPlusEvents["blur"] = "blur";
  DebouncerPlusEvents["mousedown"] = "mousedown";
  DebouncerPlusEvents["click"] = "click";
})(DebouncerPlusEvents || (exports.DebouncerPlusEvents = DebouncerPlusEvents = {}));

var useDocument = function useDocument() {
  var _react_1$default$useS = react_1.default.useState(null),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      localDocument = _react_1$default$useS2[0],
      setLocalDocument = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    setLocalDocument(document);
  }, []);
  return localDocument;
};

var useDebouncerPlus = function useDebouncerPlus(id, value, delay) {
  var idsToWatch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var stateMessenger = arguments.length > 4 ? arguments[4] : undefined;
  var isOkToDebounce = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

  var _a;

  var doc = useDocument();
  var $query = doc && ((_a = doc.querySelector) === null || _a === void 0 ? void 0 : _a.bind(doc));

  var _react_1$default$useS3 = react_1.default.useState(),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      isMounted = _react_1$default$useS4[0],
      setIsMounted = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      debouncedValue = _react_1$default$useS6[0],
      setDebouncedValue = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState([]),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      message = _react_1$default$useS8[0],
      setMessage = _react_1$default$useS8[1]; // create state array to hold the messages from PUB SUB


  var lastEventTime = react_1.default.useRef();
  var userAgent = react_1.default.useRef("");
  var timeOutId = react_1.default.useRef();
  var isUserInteracting = react_1.default.useRef(false);
  var accumulatedEvents = react_1.default.useRef([]);
  var eventsToBind = ["mousedown", "mouseout", "focus", "mouseover", "change"]; //let curTimeout: any;

  /**
   * @dec - Binds a list of events to a list of events, routing callback to to eventTracker()
   * @param elementSelector - lis of strings signifying classes,id's, or tagname
   * @param byType -to  query DOM selectors by class , id, or tagname(i.e "div" , "body" etc)
   * @param eventsList - list of events ("mousedown","mouseup" etc..) to bind for each element in elementSelector
   */

  var bindListeners = function bindListeners() {
    var elementSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : idsToWatch;
    var byType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";
    var eventsList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : eventsToBind;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : eventTracker;
    var eventBubbling = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    unBindListeners();
    var identifier = byType === "id" ? "#" : byType === "class" ? "." : "";

    if (elementSelector.length && eventsList.length) {
      elementSelector.forEach(function (selector, indexEl) {
        var El = $query && $query("".concat(identifier).concat(selector));
        eventsList.forEach(function (theEventName, indexEvent) {
          El && attachEvent(El, theEventName, callback, eventBubbling);
        });
      });
    }
  };
  /**
   * @dec - UnBinds a list of events to a list of events, routing callback to to eventTracker()
   * @param elementSelector - lis of strings signifying classes,id's, or tagname
   * @param byType -to  query DOM selectors by class , id, or tagname(i.e "div" , "body" etc)
   * @param eventsList - list of events ("mousedown","mouseup" etc..) to bind for each element in elementSelector
   */


  var unBindListeners = function unBindListeners() {
    var elementSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : idsToWatch;
    var byType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";
    var eventsList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : eventsToBind;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : eventTracker;

    if (elementSelector.length && eventsList.length) {
      var identifier = byType === "id" ? "#" : byType === "class" ? "." : "";
      elementSelector.forEach(function (selector) {
        var El = $query && $query("".concat(identifier).concat(selector));
        eventsToBind.forEach(function (theEvenName) {
          El && (El === null || El === void 0 ? void 0 : El.removeEventListener(theEvenName, callback, true));
          El === null || El === void 0 ? void 0 : El.removeAttribute("has-".concat(theEvenName));
        });
      });
    }
  };

  var attachEvent = function attachEvent(element, eventName) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : eventTracker;
    var eventBubbling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (element && eventName && !element.hasAttribute("has-".concat(eventName))) {
      element.setAttribute("has-".concat(eventName), "true");
      element.addEventListener(eventName, callback, eventBubbling);
    }
  };

  var checkElapseTimeSinceLastEvent = function checkElapseTimeSinceLastEvent() {
    var cur = Math.floor(Date.now());
    var last = Math.floor(lastEventTime.current.getTime());
    return cur - last;
  };

  var setSelectInteractionResult = function setSelectInteractionResult(event) {
    var previousEventType = accumulatedEvents.current[0] || "";
    accumulatedEvents.current.push(event);
    var selectLeaveEvents = ["blur", "change", "mouseout"];
    var selectEnterEvents = ["mousedown", "click"];

    if (selectEnterEvents.includes(event)) {
      isUserInteracting.current = true;
    }

    if (selectLeaveEvents.includes(event)) {
      // this is to mitigate the issue of firefox firing mouseout event and focus at same time!
      if (userAgent.current.includes("Firefox")) {
        var eventSequence = !!(event === "mouseout" && (previousEventType === "focus" || previousEventType === "mouseout"));

        if (!eventSequence) {
          isUserInteracting.current = false;
          setDebouncedValue(undefined);
        }
      } else {
        isUserInteracting.current = false;
        setDebouncedValue(undefined);
      }
    }

    accumulatedEvents.current.length >= 2 && accumulatedEvents.current.shift();
  };

  var eventTracker = function eventTracker(e) {
    // Record last event time
    lastEventTime.current = new Date(); // determine is select dropdown are being used

    var tagName = e.target.tagName;

    if (tagName === "SELECT") {
      setSelectInteractionResult(e.type);
    }
  };
  /** @desc -Listener for Pub Sub messages FROM other components	*/


  react_1.default.useEffect(function () {
    var _message = _slicedToArray(message, 2),
        messageString = _message[0],
        value = _message[1]; // determine is (external) select dropdown are being used


    messageString === "to-debounce" && setSelectInteractionResult(value);
  }, [message]);

  var setTimer = function setTimer() {
    publishMessage("is-debouncing", true, id);

    if (timeOutId.current) {
      clearTimeout(timeOutId.current);
      timeOutId.current = undefined;
    }

    bindListeners();
    timeOutId.current = window && (window === null || window === void 0 ? void 0 : window.setTimeout(function () {
      var haveBeenIdle = checkElapseTimeSinceLastEvent() > delay;
      var interActionComplete = !isUserInteracting.current;

      if (haveBeenIdle && interActionComplete) {
        unBindListeners();
        setDebouncedValue(value);
        clearTimeout(timeOutId.current);
        timeOutId.current = undefined;
        publishMessage("is-debouncing", false, id);
      } else {
        setTimer();
      }
    }, delay));
  }; // Use Typed a value to debounce


  react_1.default.useEffect(function () {
    setDebouncedValue(undefined);
    isUserInteracting.current = false;
    isMounted && value && isOkToDebounce && setTimer();
    isMounted && value && (lastEventTime.current = new Date());
  }, [value, delay]);

  var publishMessage = function publishMessage(MessageString, data, topic) {
    setTimeout(function () {
      return stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.publish(MessageString, data, topic);
    }, 10);
  };

  react_1.default.useEffect(function () {
    userAgent.current = window.navigator.userAgent; // Subscribe to pub-sub  stateMessenger if available

    stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function (msg, value, topic) {
      return setMessage([msg, value, topic]);
    });
    setIsMounted(true);
  }, []);
  debouncedValue && clearTimeout(timeOutId.current);
  return debouncedValue;
};

exports.default = useDebouncerPlus;